export const MIN_HODLER_APR = 0.01;
